import cardLogoBronce from '@/assets/membresia-logos/card-logo-bronce.png';
import cardLogoPlata from '@/assets/membresia-logos/card-logo-plata.png';
import cardLogoOro from '@/assets/membresia-logos/card-logo-oro.png';
import type { MembershipPlan, MonthlyBenefits, BenefitVisual, BillingPeriod } from './types';

export const planLogos: Record<MembershipPlan, string> = {
  bronce: cardLogoBronce,
  plata: cardLogoPlata,
  oro: cardLogoOro,
};

// Payment links by plan and billing period
export const PAYMENT_LINKS: Record<MembershipPlan, Record<BillingPeriod, string>> = {
  bronce: {
    mensual: 'https://villatechcr.com/Membresia-Bronce',
    anual: '', // Sin pago en línea para anual
  },
  plata: {
    mensual: 'https://villatechcr.com/Membresia-Plata',
    anual: '', // Sin pago en línea para anual
  },
  oro: {
    mensual: 'https://villatechcr.com/Membresia-Oro',
    anual: '', // Sin pago en línea para anual
  },
};

export const planGradients: Record<MembershipPlan, string> = {
  bronce: 'from-amber-700 via-amber-600 to-yellow-600',
  plata: 'from-slate-400 via-slate-300 to-gray-400',
  oro: 'from-yellow-500 via-amber-400 to-yellow-300',
};

export const planTextColors: Record<MembershipPlan, string> = {
  bronce: 'text-amber-900',
  plata: 'text-slate-800',
  oro: 'text-amber-900',
};

export const benefitTypes = [
  { value: 'vidrio_temperado', label: 'Vidrio Temperado', icon: '🛡️' },
  { value: 'estuche', label: 'Estuche', icon: '📱' },
  { value: 'limpieza', label: 'Limpieza', icon: '✨' },
  { value: 'hidrogel', label: 'Hidrogel Premium', icon: '💎' },
];

// Visual metadata for benefit cards
export const benefitVisuals: Record<string, BenefitVisual> = {
  vidrio_temperado: {
    icon: 'Shield',
    iconBg: 'from-blue-500 to-cyan-500',
    imageBg: 'from-blue-600 via-blue-700 to-cyan-800',
    description: 'La mejor protección del mercado',
  },
  estuche: {
    icon: 'Smartphone',
    iconBg: 'from-amber-500 to-orange-500',
    imageBg: 'from-amber-600 via-orange-700 to-red-800',
    description: 'Calidad superior garantizada',
  },
  limpieza: {
    icon: 'Sparkles',
    iconBg: 'from-purple-500 to-pink-500',
    imageBg: 'from-purple-600 via-pink-700 to-rose-800',
    description: 'El máximo cuidado para tu dispositivo',
  },
  hidrogel: {
    icon: 'Gem',
    iconBg: 'from-cyan-500 to-blue-500',
    imageBg: 'from-cyan-600 via-teal-700 to-emerald-800',
    description: 'Protección invisible premium',
  },
};

export const monthlyBenefits: Record<MembershipPlan, MonthlyBenefits> = {
  bronce: {
    'vidrio_temperado': { name: 'Temperado Sencillo o Hidrogel HD', max: 1, icon: '🛡️' },
    'estuche': { name: 'Estuche Space', max: 1, icon: '📱' },
    'limpieza': { name: 'Limpieza', max: 2, icon: '✨' },
  },
  plata: {
    'vidrio_temperado': { name: 'Temperado Completo o Hidrogel Mate/Restaurativo', max: 2, icon: '🛡️' },
    'estuche': { name: 'Estuche Space MagSafe', max: 2, icon: '📱' },
    'limpieza': { name: 'Limpieza', max: 2, icon: '✨' },
  },
  oro: {
    'hidrogel': { name: 'Temperado Privado o Hidrogel Premium', max: 2, icon: '💎' },
    'estuche': { name: 'Estuche Premium o MagSafe', max: 1, icon: '📱' },
    'limpieza': { name: 'Limpieza', max: 3, icon: '✨' },
  },
};
